$(document).ready(function(){

	var sliderFigures = $('.slider--figures');
	sliderFigures.slick({
		'arrows': true,
		'slidesToShow': 1,
		'infinite': true,
		'centerMode': true,
		'variableWidth': true,
		'responsive': [
		  {
		    'breakpoint': 1092,
		    'settings': {
		      'infinite': false,
		      'centerMode': false,
		      'variableWidth': false,
		    }
		  }
		]
	});

	var sliderBanners = $('.slider--banners');
	sliderBanners.slick({
		'arrows': true,
		'dots': true,
		'slidesToShow': 1,
		'infinite': false,
		'autoplay': true,
  	'autoplaySpeed': 5000,
	});

});